/************************************
MODULE: PROMO BLOCK MESSAGE ON STORE PAGES
WHAT IT DOES: LOGIC FOR THE BLOCK
*************************************/

(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    } else if (typeof exports === 'object') {
        module.exports = factory(require('jquery'));
    } else {
        root.returnExports = factory(root.jQuery);
    }
}(this, function ($) {

    function Promo(el) {
        this.$container = $(el);
        this.container = this.$container[0];
        this.isMovable = this.$container.hasClass('js-promo-move');

        this.init();
    }

    $.extend(Promo.prototype, {
        init: function() {
            if(this.isMovable) {
                this.anchor = this.$container.next();
                this.anchor = this.anchor.length ? this.anchor[0] : null;
                this.parent = this.$container.parent()[0];

                var next = this.$container.parent(),
                    current = this.$container;

                while(!next.hasClass('js-content')) {
                    current = next;
                    next = next.parent();
                }

                this.mobileAnchor = current.next().next()[0];
                this.mobileParent = next[0];

                this.isDefault = true;

                $(window).on('resize:finished', this.resize.bind(this));
                this.resize();
            }
        },
        resize: function() {
            this[window.App.globals.isMobileSmall ? "toMobile" : "toDefault"]();
        },
        toDefault: function() {
            if(this.isDefault) {
                return;
            }
            this.isDefault = true;

            this.parent.insertBefore(this.container, this.anchor);

        },
        toMobile: function() {
            if(!this.isDefault) {
                return;
            }
            this.isDefault = false;

            this.mobileParent.insertBefore(this.container, this.mobileAnchor);
        }
    });

    return Promo;

}));



/*****************
 ** WEBPACK FOOTER
 ** ./js/app/generic/generic.promo.js
 ** module id = 26
 ** module chunks = 24
 **/